function Problem() {
  return (
    <section id="problem" className="py-5 problem-section" data-aos="zoom-out" data-aos-delay="100">
      <div className="container text-center ">
        <i className="fas fa-question-circle fa-8x mb-5 icon"></i>
        <h2 className="mb-5 display-3">Why We Do This?</h2>
        <p className="mb-5 problem-caption">In rural Sri Lanka, free-range cattle often damage crops, cause road accidents, and are hard to find when lost or stolen. This harms farmers’ incomes and safety.
           <br/><br/>Existing smart farming systems are too costly, complicated, and depend on networks that don’t work well in these areas. <br/><br/>Farmers need a simple, low-cost solution they can manage easily.</p>
      </div>
    </section>
  );
}

export default Problem;
